import { SerializableCreditOffering } from 'types/Serializable'
import { deserializeTranche, serializeTranche } from 'backend/serialization/Tranche'
import { deserializeToken, serializeToken } from 'backend/serialization/Token'
import { serializeBigNumber } from 'backend/serialization/BigNumber'
import { BigNumber } from 'ethers'
import { CreditOffering } from 'types/Portfolio/StructuredOffering'
import { deserializeOfferingCheckpoint, serializeOfferingCheckpoint } from 'backend/serialization/OfferingCheckpoint'
import {
  deserializeOfferingInitialDrawdown,
  serializeOfferingInitialDrawdown,
} from 'backend/serialization/OfferingInitialDrawdown'

export function serializeCreditOffering(instance: CreditOffering): SerializableCreditOffering {
  return {
    ...instance,
    latestCheckpoint: serializeOfferingCheckpoint(instance.latestCheckpoint),
    tranches: instance.tranches.map(serializeTranche),
    asset: serializeToken(instance.asset),
    startDate: instance.startDate.toJSON(),
    endDate: instance.endDate.toJSON(),
    creationDate: instance.creationDate.toJSON(),
    startDeadline: instance.startDeadline.toJSON(),
    minimumSize: serializeBigNumber(instance.minimumSize),
    totalAccruedInterest: serializeBigNumber(instance.totalAccruedInterest),
    totalInterestDisbursed: serializeBigNumber(instance.totalInterestDisbursed),
    capitalRaisingStrategy: instance.capitalRaisingStrategy,
    minimumInvestorCommitment: serializeBigNumber(instance.minimumInvestorCommitment),
    initialDrawdown: serializeOfferingInitialDrawdown(instance.initialDrawdown),
  }
}

export function deserializeCreditOffering(json: SerializableCreditOffering): CreditOffering {
  return {
    ...json,
    latestCheckpoint: deserializeOfferingCheckpoint(json.latestCheckpoint),
    tranches: json.tranches.map(deserializeTranche),
    asset: deserializeToken(json.asset),
    startDate: new Date(json.startDate),
    endDate: new Date(json.endDate),
    creationDate: new Date(json.creationDate),
    startDeadline: new Date(json.startDeadline),
    minimumSize: BigNumber.from(json.minimumSize),
    totalAccruedInterest: BigNumber.from(json.totalAccruedInterest),
    totalInterestDisbursed: BigNumber.from(json.totalInterestDisbursed),
    capitalRaisingStrategy: json.capitalRaisingStrategy,
    minimumInvestorCommitment: BigNumber.from(json.minimumInvestorCommitment),
    initialDrawdown: deserializeOfferingInitialDrawdown(json.initialDrawdown),
  }
}
